export default "__VITE_ASSET__CbUi_qaE__"